import React from 'react'
import { Grid,Theme,Avatar,Typography} from '@mui/material'
import { createStyles, makeStyles } from "@mui/styles";
import useFilteredProviders from 'hooks/useFiltereProviders';
import { useStore } from 'store/StoreProvider';
import moment from 'moment';
const useStyles = makeStyles((theme:Theme) =>
    createStyles({
        selectedDRMainBody:{
            display:"flex",
            gap:"20px",
            paddingTop:"20px"
        },
        scheduleTimeTitle:{
            fontSize:"1.1428571429rem !important",
            color:"#3D5A80 !important",
            fontWeight:"600 !important",
            fontFamily: 'Open Sans !important',
            [theme.breakpoints.down('sm')]:{
             textAlign:"center",
             fontSize:"0.9rem !important",   
            }
        }, 
         DRDetailsTitle:{
            fontFamily: 'Open Sans !important',
            fontSize:"1.0428571429rem !important",
            color:"#545454!important",
            fontWeight:"600 !important",
            [theme.breakpoints.down('sm')]:{
              textAlign:"center",
              fontSize:"0.8rem !important",   
            }
        },
        
        AddressTitle:{
            fontFamily: 'Open Sans !important',
            fontSize:"1.0428571429rem !important",
            color:"#545454!important",
            [theme.breakpoints.down('sm')]:{
             textAlign:"center",
             fontSize:"0.8rem !important",   
            }
        },
    })
  );

function SelectedDRProfile() {
  const classes = useStyles();
  const store= useStore();
  const data = store.getData();
  const selectedDateTime = store.getSelectedDateTime();
  const fullDayName = moment(selectedDateTime?.date).format('dddd');
  const shortMonthName = moment(selectedDateTime?.date).format('MMMM');
  const dayOfMonth = moment(selectedDateTime?.date).format('D');
  const year = moment(selectedDateTime?.date).format('YYYY');
  const DRDetails=useFilteredProviders(data?.Providers,selectedDateTime?.doctorId)
  const AddressDetails=useFilteredProviders(data?.Addresses,selectedDateTime?.addressID)
  return (
    <Grid className={classes.selectedDRMainBody}>
        {/* <Grid>
            <Grid>
                <Avatar alt={DRDetails?.first_name}
                src="#"
                sx={{ width: 56, height: 56 }}>
                </Avatar>
            </Grid>
        </Grid> */}
        <Grid sx={{width:"100%"}}>
            <Grid>
                <Typography variant='body2' className={classes.scheduleTimeTitle}>{`${fullDayName}, ${shortMonthName} ${dayOfMonth}, ${year} at ${selectedDateTime?.time}`}</Typography>
            </Grid>
            <Grid>
                <Typography variant='body2' className={classes.DRDetailsTitle}>{`${DRDetails?.first_name} ${DRDetails?.last_name}: ${DRDetails?.public_name}`}</Typography>
            </Grid>
             <Grid>
                <Typography variant='body2' className={classes.AddressTitle}>{`${AddressDetails?.address_line_one}, ${AddressDetails?.city}, ${AddressDetails?.state}, ${AddressDetails?.zip_code} ${AddressDetails?.county? +","+ AddressDetails?.county:""}`}</Typography>
            </Grid>
        </Grid>
    </Grid>
  )
}

export default SelectedDRProfile